import Phaser from 'phaser';
import i18next from 'i18next';
import { isWebPlayLocked, shouldShowBuyPrompt } from '@/game/promo';
import { createStoreBadges } from '@/game/ui/storeBadges';
import { showPromoCard } from '@/game/ui/promoCard';
import { showWebLimitCard } from '@/game/ui/webLimitCard';
import { getActivePack, packKey } from '@/game/packs';

/**
 * The web-only "buy the app" card, shown after a game once the player has earned enough stars
 * (see src/game/promo.ts for the why and the threshold). Dismissible and non-blocking, but it
 * comes back after every game — the free web build is the demo, the paid app is the product.
 *
 * A no-op in the iOS and Android builds: those players already bought it.
 */
export function maybeShowBuyPrompt(scene: Phaser.Scene, opts: { delayMs?: number } = {}): void {
  // Past the free allowance the ask is no longer "buy it" but "continue in the app" — the game
  // that just ended was the last one this build will start (src/game/ui/webLimitCard.ts).
  if (isWebPlayLocked(packKey(getActivePack()))) {
    showWebLimitCard(scene, { delayMs: opts.delayMs ?? 1200 });
    return;
  }
  if (!shouldShowBuyPrompt()) return;

  showPromoCard(scene, {
    title: i18next.t('buy.title'),
    lines: [i18next.t('buy.once'), i18next.t('buy.coffee'), i18next.t('buy.offline')],
    extra: createStoreBadges({ height: 46 }),
    actions: [{ label: i18next.t('buy.later'), kind: 'ghost' }],
  }, { delayMs: opts.delayMs ?? 1200 });
}
